/* eslint-disable no-nested-ternary */
import createAction from '@clearscore/helpers.create-action';
import createRequestPayload from '@clearscore/helpers.create-request-payload';

export const fetchHasNewNotifications = (TYPE) => () =>
    createAction(TYPE, createRequestPayload('international', '/notifications/v1/notifications/hasNew'));

export const fetch = (TYPE) => () =>
    createAction(TYPE, createRequestPayload('international', '/notifications/v1/notifications'));

export const trackNotificationsClick = (TYPE) => (id, title, description, destination, rank, isSeen) =>
    createAction(TYPE, {
        context: {
            id,
            title,
            description,
            destination,
            rank: rank + 1,
            viewType: isSeen ? 'repeat_view' : 'first_view',
        },
    });

export const trackNotificationIconSeen = (TYPE) => (isBadgeShown, status) =>
    createAction(TYPE, {
        context: {
            isBadgeShown,
            status,
        },
    });
